import { useQuery } from "@tanstack/react-query";
import { getRoles } from "../../api";

export const useGetRoles = () => {
    const query = useQuery({
      queryKey: ["roles"],
      queryFn: () => getRoles(),
    });
    return {
      isLoading: query.isPending,
      isSuccess: query.isSuccess,
      isError: query.isError,
      data: query.data,
      refetch: query.refetch,
    };
  };
